import request from '../../config/axiosConfig';
import {
  GET_LIST_EVENT_TYPES, CREATE_EVENT_TYPE,
  UPDATE_EVENT_TYPE, DELETE_EVENT_TYPE, LIST_ACTIVE_EVENT_TYPES
} from '../../constants/apiEndPoint';

const eventTypeService = {
  // Controller đọc limit/page/từ khóa từ req.body (validator đóng) nên phải gửi body whitelist,
  // và map từ khóa chung "search" của CrudPage sang đúng key "name" API nhận
  getList: async (params = {}) => {
    const { page = 1, limit = 10, search, name, status, event_category_id } = params;
    const body = { page, limit };
    const term = name ?? search;
    if (term) body.name = term;
    // Filter "Tất cả" gửi '' — Joi.number() sẽ reject nên chỉ gửi khi có giá trị thật
    if (status !== undefined && status !== null && status !== '') body.status = Number(status);
    if (event_category_id !== undefined && event_category_id !== null && event_category_id !== '') body.event_category_id = Number(event_category_id);
    const { data } = await request({ url: GET_LIST_EVENT_TYPES, method: 'POST', data: body });
    return data;
  },

  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_EVENT_TYPE, method: 'POST', data: dataBody });
    return data;
  },

  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_EVENT_TYPE, method: 'POST', data: { id, ...dataBody } });
    return data;
  },

  delete: async (id) => {
    const { data } = await request({ url: DELETE_EVENT_TYPE, method: 'POST', data: { id } });
    return data;
  },

  listActive: async () => {
    const { data } = await request({ url: LIST_ACTIVE_EVENT_TYPES, method: 'POST' });
    return data?.data || data;
  },
};

export default eventTypeService;
